
import { Injectable } from '@angular/core';
import { formatDate } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor() {}

  // info type log, will be printed in white font color
  info(msg : any, tag : string, data : any = '') {
    this.msg("info", "1", msg, tag, data);
  }

  // warn type log, will be printed in yellow font color
  warn(msg : any, tag : string, data : any = '') {
    this.msg("warn", "2", msg, tag, data);
  }

  // error type log, will be printed in red font color
  error(msg : any, tag : string, data : any = '') {
    this.msg("error", "3", msg, tag, data);
  }

  // debug type log
  debug(msg : any, tag : string, data : any = '') {
    this.msg("debug", "4", msg, tag, data);
  }



  msg(logtype: string, lvl : string, msg : any, tag : string, data : any = '') {

    // read from localstorage
    // co_loglvl + co_logtag
    const ls_lvl = localStorage.getItem("co_loglvl") || ""

    // Reading ls_tag
    const ls_tag = localStorage.getItem("co_logtag")  || "none"
    
    // just get out of here, if ls_tag is "none" ... we do not want any logging in that case
    if (ls_tag == "none") {return}

    // check ls_lvl is smaller than lvl coming in to print that message
    // if (ls_lvl <= lvl) {
    if ( 3==3 ) {
      // check that tag is matched to print message
      // tag = * ...... print anything
      // tag = none ... never print
      // tag = foo .... only print foo messages
      if ( ls_tag == "*" || ls_tag.match(tag) != null ) { 
        const currentDate = Date.now();
        const format = 'hh:mm:ss.SSS';
        const zone =  'en-US';

        const parsedDate = formatDate( currentDate,format, zone);

        let logData = `${parsedDate}, [log level:${lvl}, log tag:${tag}], ${msg}, ${data}`;

        // log
        console[logtype](logData);
      }
    }
  } 
}